import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { displayBinaryImage, roundToTwoDecimals } from "Helper";
import PdfSopCover from "./PdfSopCover";
import { decryptNik } from "Config/cripto";

const styles = StyleSheet.create({
  page: { padding: 20, fontFamily: "Helvetica" },
  title: { fontSize: 20, fontWeight: "bold", marginBottom: 10 },
  table: { width: "100%", borderWidth: 1, borderColor: "#000" },
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
    alignItems: "center",
    minHeight: 70, // Tinggi minimum untuk row
  },
  header: {
    backgroundColor: "#2D3E50",
    fontWeight: "bold",
    textAlign: "center",
    padding: 5,
    minHeight: 30, // Tinggi header
  },
  cellNo: {
    width: "5%",
    padding: 5,
    fontSize: 12,
    textAlign: "center",
  },
  cellImage: {
    width: "12%",
    padding: 5,
    textAlign: "center",
  },
  cellImageFull: {
    width: "18%",
    padding: 5,
    textAlign: "center",
  },
  cellName: {
    width: "25%",
    padding: 5,
    fontSize: 12,
    textAlign: "left",
  },
  cellNik: {
    width: "20%",
    padding: 5,
    fontSize: 12,
    textAlign: "center",
  },
  cellDpo: {
    width: "10%",
    padding: 5,
    fontSize: 12,
    textAlign: "center",
  },
  imageCell: {
    width: 50,
    height: 60,
    borderRadius: 3,
    objectFit: "cover",
    backgroundColor: "#000",
    borderWidth: 1,
    marginHorizontal: 10,
    borderColor: "#000",
  },
  imageCellFullFace: {
    width: 100,
    height: 60,
    borderRadius: 3,
    objectFit: "cover",
    backgroundColor: "#000",
    borderWidth: 1,
    borderColor: "#000",
  },
  // Style untuk header cells
  headerCell: {
    color: "#FFFFFF",
    fontSize: 12,
    textAlign: "center",
    padding: 5,
  },
});

const PdfReport = ({ targets, detailData, dataDetail }) => {
  const allData = dataDetail?.data;
  return (
    <Document>
      <PdfSopCover data={detailData} targets={dataDetail?.data} />

      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>Target Report</Text>

        <View style={styles.table}>
          {/* Header */}
          <View style={styles.header}>
            <View style={{ flexDirection: "row" }}>
              <Text style={[styles.headerCell, styles.cellNo]}>No</Text>
              <Text style={[styles.headerCell, styles.cellName]}>Nama</Text>
              <Text style={[styles.headerCell, styles.cellNik]}>Nik</Text>
              <Text style={[styles.headerCell, styles.cellImage]}>Crop</Text>
              <Text style={[styles.headerCell, styles.cellImageFull]}>
                Capture
              </Text>
              <Text style={[styles.headerCell, styles.cellImage]}>Target</Text>

              <Text style={[styles.headerCell, styles.cellDpo]}>DPO</Text>
            </View>
          </View>

          {/* Table Content */}
          {allData?.map((target, index) => (
            <View key={target?.id || index} style={styles.row}>
              <Text style={styles.cellNo}>{index + 1}</Text>
              <Text style={styles.cellName}>
                {roundToTwoDecimals(target?.similarity)}%{"\n"}
                {target?.nama_target}
              </Text>

              <Text style={styles.cellNik}>
                {decryptNik(target?.nik_target)}
              </Text>
              <View style={styles.cellImage}>
                <Image
                  // src={displayBinaryImage(target?.crop_image)}
                  src={target?.crop_image}
                  style={styles.imageCell}
                />
              </View>

              <View style={styles.cellImageFull}>
                <Image
                  // src={displayBinaryImage(target?.full_frame)}
                  src={target?.full_frame}
                  style={styles.imageCellFullFace}
                />
              </View>

              <View style={styles.cellImage}>
                <Image
                  // src={displayBinaryImage(target?.person_face)}
                  src={target?.person_face}
                  style={styles.imageCell}
                />
              </View>

              <Text
                style={[
                  styles.cellDpo,
                  target?.is_dpo && {
                    color: "red",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  },
                ]}
              >
                {target?.is_dpo ? "DPO" : "-"}
              </Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default PdfReport;
